import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const positions = new Map<string, number>();
/** A full-page case can return to the same filtered list and its previous position. */
export function useListScroll(ready = true) {
  const location = useLocation();
  const key = location.pathname + location.search;
  useLayoutEffect(() => {
    if (!ready) return;
    const position = positions.get(key) ?? 0;
    const frame = window.requestAnimationFrame(() =>
      window.scrollTo({ top: position, behavior: "instant" }),
    );
    const remember = () => positions.set(key, window.scrollY);
    window.addEventListener("scroll", remember, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", remember);
    };
  }, [key, ready]);
}
